import { render, staticRenderFns } from "./AddNewAdvert.vue?vue&type=template&id=b029df86&lang=pug&"
import script from "./AddNewAdvert.vue?vue&type=script&lang=js&"
export * from "./AddNewAdvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports